import React from "react";
import styled from "styled-components";
import Table from "components/Table";
import { Icon, Text } from "@sproutsocial/racine";
import useComponentProps from "queries/useComponentProps";
import "array-flat-polyfill";

const StyledTable = styled(Table)`
  td {
    vertical-align: middle;
  }
`;

const Type = ({ name, raw, elements }) => {
  if (name === "union" && elements) {
    const filteredElements = elements.filter(
      (element) => element.name !== "unknown"
    );

    return (
      <>
        {filteredElements.map((element, i) => (
          <Text as="div" mr={300} my={200} key={i} breakWord={false}>
            <code
              css={`
                white-space: nowrap;
              `}
            >
              |&nbsp;{element.raw || element.value || element.name}
            </code>
          </Text>
        ))}
      </>
    );
  }

  return <code>{raw || name}</code>;
};

const ScrollableText = styled(Text)`
  max-width: 300px;
  max-height: 350px;
  overflow-y: auto;
`;

// Allow scrolling on long text
const StyledTD = ({ children, ...props }) => {
  return (
    <td {...props}>
      <ScrollableText as="div" breakWord={false}>
        {children}
      </ScrollableText>
    </td>
  );
};

const Row = ({
  name,
  partial,
  type,
  description,
  defaultValue,
  required,
  ...rest
}) => {
  if (!!description) {
    if (description.startsWith("DEPRECATED")) return null;
  }

  if (!type) return null;

  return (
    <tr>
      <StyledTD>
        <code>{name}</code>
      </StyledTD>
      <StyledTD>
        <Type {...type} />
      </StyledTD>
      <StyledTD>
        {defaultValue !== null ? <code>{defaultValue?.value}</code> : ""}
      </StyledTD>
      <StyledTD>
        <Text as="div" fontSize={200}>
          {description ? description : ""}
        </Text>
      </StyledTD>
      <StyledTD
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {required && !partial ? (
          <Icon color="neutral.800" name="check-outline" />
        ) : (
          ""
        )}
      </StyledTD>
    </tr>
  );
};

// partial prop can be used to force all props to be optional
const PropTable = ({ name, partial, ...rest }) => {
  const componentProps = useComponentProps(name);
  if (!componentProps || componentProps.length === 0) {
    return null;
  }

  return (
    <StyledTable className="medium" {...rest}>
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Default</th>
          <th>Description</th>
          <th
            css={`
              text-align: center;
            `}
          >
            Required?
          </th>
        </tr>
      </thead>

      <tbody>
        {componentProps.map((prop, i) => (
          <Row partial={partial} {...prop} key={i} />
        ))}
      </tbody>
    </StyledTable>
  );
};

export default PropTable;
